import { queryTask, queryMode, IdentifyTaskAsync } from "../../utils/querying/gis-data";
export function getFeatures(options) {
    return queryTask({
        url: options.url,
        returnGeometry: options.returnGeometry,
        outFields: options.outFields,
        where: options.where,
        mode: queryMode.Features,
        geometry: options.geometry,
        spatialRelationship: options.spatialRelationship,
        num: options.num,
        start: options.start,
        returnDistinctValues: options.returnDistinctValues,
        objectIds: options.objectIds,
        orderByFields: options.orderByFields,
    });
}
export function getFeaturesCount(options) {
    return queryTask({
        url: options.url,
        returnGeometry: options.returnGeometry,
        outFields: options.outFields,
        where: options.where,
        mode: queryMode.FeatureCount,
        geometry: options.geometry,
        spatialRelationship: options.spatialRelationship,
        num: options.num,
        start: options.start,
        returnDistinctValues: options.returnDistinctValues,
        objectIds: options.objectIds,
        orderByFields: options.orderByFields,
    });
}
export function identifyTask(settings) {
    return IdentifyTaskAsync(settings).then(respones => {
        return respones;
    });
}
